import * as R from 'ramda'

export const deserializeEvent = R.path([
  'RequestBorn',
  'returnValues',
  '_requestHash'
])
